module.exports = __webpack_public_path__ + "static/media/SUPERINOX.1051baa7.jpg";